import { Box, Typography, Link } from "@mui/material";
import { TEXT_SECONDARY, DELTA_ACCENT } from "../colors";

export const Footer = () => {
  return (
    <Box
      component="footer"
      style={{
        textAlign: "center",
        padding: "24px 20px",
        marginTop: 40,
      }}
    >
      <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
        <Link
          href="https://www.deltagain.co.uk"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: DELTA_ACCENT, textDecoration: "none", fontWeight: 600 }}
        >
          DeltaGain Ltd
        </Link>
        {" | UK Company 08778714 | © DeltaGain Ltd "}
        {new Date().getFullYear()}
      </Typography>
    </Box>
  );
};

export default Footer;
